import axios, { AxiosError, AxiosResponse } from 'axios';
import { useEffect } from 'react';
import { Config } from '../models/config';
import { ceV2Axios, k1Axios, k1V2Axios } from './axios';

export const useResponseInterceptor = <T = any>(
  onFulfilled: (result: AxiosResponse<T>) => AxiosResponse,
  onRejected: (error: AxiosError<T>, config: Config | undefined)
  => Promise<AxiosResponse | AxiosError | null>,
  config: Config | undefined,
) => {
  useEffect(() => {
    const handleError = async (responseError: AxiosError<T, any>) => {
      const result = await onRejected(responseError, config);
      if (result instanceof AxiosError) {
        return Promise.reject(result);
      }
      return Promise.resolve(result);
    };

    if (!config) return;
    axios.interceptors.response.use(
      onFulfilled,
      handleError,
    );
    ceV2Axios.interceptors.response.use(
      onFulfilled,
      handleError,
    );
    k1Axios.interceptors.response.use(
      onFulfilled,
      handleError,
    );
    k1V2Axios.interceptors.response.use(
      onFulfilled,
      handleError,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config]);
};
